import * as types from './types';

export default {
  /**
   * Define o estado de carregamento do módulo.
   * @param {object} state - O estado atual do módulo.
   * @param {boolean} isLoading - O novo estado de carregamento.
   */
  [types.SET_LOADING](state, isLoading) {
    state.isLoading = isLoading;
  },

  /**
   * Define a mensagem de erro do módulo.
   * @param {object} state - O estado atual do módulo.
   * @param {string|null} error - A mensagem de erro ou nulo.
   */
  [types.SET_ERROR](state, error) {
    state.error = error;
  },

  /**
   * Armazena a lista de links compartilhados no estado.
   * @param {object} state - O estado atual do módulo.
   * @param {Array} links - A lista de links recebida da API.
   */
  [types.SET_LINKS](state, links) {
    state.links = links;
  },

  /**
   * Atualiza um único link na lista de links existente.
   * @param {object} state - O estado atual do módulo.
   * @param {object} updatedLink - O objeto do link atualizado.
   */
  [types.UPDATE_LINK_IN_LIST](state, updatedLink) {
    const index = state.links.findIndex(link => link.id === updatedLink.id);
    if (index !== -1) {
      Vue.set(state.links, index, updatedLink);
    }
  },

  /**
   * Limpa o estado do módulo, retornando ao estado inicial.
   * @param {object} state - O estado atual do módulo.
   */
  [types.CLEAR_STATE](state) {
    state.isLoading = false;
    state.error = null;
    state.links = [];
  },
};
